import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getAllVisibleAccounts,
  getAsOfDate,
  getIntradayAccounts
} from 'state/account/AccountSelectors';
import {
  getModelName,
  getPreferredPortfolioName,
  getCustomerPlanningGroupId
} from 'state/customer/CustomerSelectors';
import { getIntradayPricing } from 'services/Rest';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';

const AccountsDataProvider = (WrappedComponent) => {
  class AccountsData extends Component {
    render() {
      const {
        accounts,
        asOfDate,
        filter,
        hasIntradayRefresh,
        modelName,
        preferredPortfolioName,
        customerPlanningGroupId,
        requestStatus,
        intradayAccounts
      } = this.props;

      let accountsData = accounts.filter(filter);
      const { intradayPricing } = requestStatus;

      if (hasIntradayRefresh && intradayPricing === REQUEST_STATES.received) {
        accountsData = intradayAccounts.filter(filter);
      }

      const data = {
        accounts: accountsData,
        asOfDate: asOfDate || null,
        modelName: modelName,
        preferredPortfolioName: preferredPortfolioName,
        customerPlanningGroupId
      };

      return (
        <WrappedComponent
          data={data}
          onRefresh={getIntradayPricing}
          {...this.props}
        />
      );
    }
  }
  AccountsData.defaultProps = {
    hasIntradayRefresh: false
  };
  const mapStateToProps = (state) => ({
    accounts: getAllVisibleAccounts(state),
    asOfDate: getAsOfDate(state),
    modelName: getModelName(state),
    preferredPortfolioName: getPreferredPortfolioName(state),
    customerPlanningGroupId: getCustomerPlanningGroupId(state),
    requestStatus: getRequestStatus(state),
    intradayAccounts: getIntradayAccounts(state)
  });
  return connect(mapStateToProps)(AccountsData);
};

export default AccountsDataProvider;
